import { Toast } from '../../../../components/Common/Toast';
import { callAPI } from '../../../../services/api.service';

// Fulfillment business dashboard (funnel / conversion / revenue / health).

export const fetchFulfillmentDashboard = async (): Promise<any | null> => {
  try {
    const response = await callAPI('admin/dashboard/fulfillment');
    if (response?.funnel) return response;
    // callAPI resolves (never throws) on HTTP errors and returns null on timeouts — without
    // this branch a server 4xx/5xx rendered empty tiles with no feedback at all.
    Toast(response?.error || 'Failed to load fulfillment dashboard', true);
    return null;
  } catch {
    Toast('Failed to load fulfillment dashboard', true);
    return null;
  }
};

// Audience dashboard (registrations / classrooms / 30d signup series). Mirrors AudienceDashboard
// in server/src/services/AudienceDashboard.service.ts.

export interface SignupPoint {
  /** UTC day, YYYY-MM-DD. */
  date: string;
  teachers: number;
  parents: number;
}

export interface AudienceDashboard {
  registrations: {
    teachers: number;
    teachers30d: number;
    parents: number;
    parents30d: number;
    active30d: number;
    onboardedTeachers: number;
  };
  classrooms: {
    total: number;
    new30d: number;
    students: number;
    avgStudentsPerClassroom: number | null;
    projects: number;
    projectsActive: number;
    projectsCompleted: number;
  };
  signupSeries: SignupPoint[];
  signupSeriesTruncated: boolean;
  generatedAt: string;
}

export const fetchAudienceDashboard = async (): Promise<AudienceDashboard | null> => {
  try {
    const response = await callAPI('admin/dashboard/audience');
    if (response?.registrations) return response;
    // Same as above: HTTP-level failures resolve rather than throw.
    Toast(response?.error || 'Failed to load audience dashboard', true);
    return null;
  } catch {
    Toast('Failed to load audience dashboard', true);
    return null;
  }
};
